import { render, staticRenderFns } from "./notice-publicity.vue?vue&type=template&id=d5a6b736&scoped=true&"
import script from "./notice-publicity.vue?vue&type=script&lang=js&"
export * from "./notice-publicity.vue?vue&type=script&lang=js&"
import style0 from "./notice-publicity.vue?vue&type=style&index=0&id=d5a6b736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a6b736",
  null
  
)

export default component.exports